exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 575px) {\n.item-list[data-v-093b1b8a] .outer-box span {\n      white-space: normal;\n      word-wrap: break-word;\n}\n}\n", ""]);

// exports
